import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-94eb03ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-info-wrap" }
const _hoisted_2 = { class: "filter-row" }
const _hoisted_3 = {
  style: {"display":"flex"},
  class: "cm-ui-mr10"
}
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { class: "log-content-wrap cm-shadow-card" }

import { defineComponent, PropType, reactive, ref, watch } from 'vue'
import { downloadTxt } from '@/utils/tool'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { CoreServiceData } from '@/views/dashboard/manage/run-status/_components/core-services/core-services.service'
import {
  LogDrawerService, TAIL_LINE_LIST
} from '@/views/dashboard/manage/run-status/_components/core-services/log-drawer/log-drawer.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'log-drawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  serviceData: {
    type: Object as PropType<CoreServiceData>,
    default: {} as PropType<CoreServiceData>
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const injector = useReflectiveInjector([LogDrawerService])
const logDrawerService = injector.get(LogDrawerService)

const isLoading = ref(false)
const logList = ref<string[]>([])
const queryParams = reactive({
  tailLine: 200,
})

function handleClose () {
  emits('update:modelValue', false)
}

function updateData () {
  isLoading.value = true
  return logDrawerService.getServiceLogs({
    core_service_id: props.serviceData.core_service_id,
    tail_lines: queryParams.tailLine,
  }).then(response => {
    logList.value = response.data || []
  }).finally(() => {
    isLoading.value = false
  })
}

function download () {
  downloadTxt({
    text: logList.value?.join('\n'),
    name: props.serviceData.name,
    isJoinTime: true
  })
}

watch(() => props.modelValue, (value) => {
  if (value) {
    updateData()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    title: `【${__props.serviceData.name}】服务日志`,
    "model-value": __props.modelValue,
    "show-close": "",
    size: 1000,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: download,
              disabled: !logList.value.length
            }, {
              default: _withCtx(() => [
                _createTextVNode("导出日志")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_select, {
              modelValue: queryParams.tailLine,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.tailLine) = $event)),
              size: "small",
              placeholder: "请选择行数限制",
              onChange: updateData
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAIL_LINE_LIST), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: `最后${item}行`,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "log-item",
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(item), 1)
            ]))
          }), 128)),
          (!logList.value.length)
            ? (_openBlock(), _createBlock(EmptyData, {
                key: 0,
                height: "100%"
              }))
            : _createCommentVNode("", true)
        ])
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})